var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gender-chart"}},[_c('vue-apex-charts',{attrs:{"type":"donut","height":"194","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }